import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { CLINICAL_SERVICES } from '../constants/clinicData';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';

const ClinicalFocus = () => {
  const { t } = useTranslation();
  const sectionRef = useScrollReveal();

  return (
    <section id="services" className="py-20 px-4 bg-slate-50" ref={sectionRef}>
      <div className="container mx-auto max-w-6xl">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 text-center scroll-reveal">
          {t('services.title')}
        </h2>
        <div className="w-20 h-1 mx-auto mb-12 scroll-reveal" style={{ backgroundColor: 'var(--medical-primary)', animationDelay: '0.1s' }}></div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {CLINICAL_SERVICES.map((service, index) => {
            const Icon = service.icon;
            return (
              <Card 
                key={service.titleKey}
                className="card-hover scroll-reveal-scale border-0 bg-white shadow-lg overflow-hidden group flex flex-col min-h-[280px]" 
                style={{ 
                  animationDelay: `${0.2 + index * 0.05}s`,
                  boxShadow: '0 4px 15px rgba(5, 56, 39, 0.08)'
                }}
              >
                <CardHeader className="relative pb-4 flex-shrink-0">
                  <div 
                    className="absolute top-0 left-0 w-full h-1 transition-all duration-300 group-hover:h-2" 
                    style={{ 
                      background: 'linear-gradient(90deg, #053827 0%, #10b981 100%)'
                    }}
                  />
                  <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-3 transition-all duration-300 group-hover:scale-110" 
                    style={{ 
                      background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)',
                      boxShadow: '0 2px 10px rgba(5, 56, 39, 0.1)'
                    }}
                  >
                    <Icon style={{ color: 'var(--medical-primary)' }} size={24} />
                  </div>
                  <CardTitle className="text-lg font-semibold line-clamp-2">{t(`services.${service.titleKey}`)}</CardTitle>
                </CardHeader>
                <CardContent className="flex-grow flex flex-col">
                  <p className="text-slate-600 text-sm leading-relaxed mb-4 flex-grow line-clamp-4">{t(`services.${service.descKey}`)}</p>
                  <Link to={`/service/${service.titleKey}`}>
                    <Button
                      variant="outline"
                      size="sm"
                      className="w-full border-2 transition-all duration-300 hover:scale-105"
                      style={{ borderColor: 'var(--medical-primary)', color: 'var(--medical-primary)' }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#f0fdf4';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '';
                      }}
                    >
                      <ArrowRight className="mr-2" size={16} />
                      View Full Details
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ClinicalFocus;